<template>
  <div class="mt-3" v-if="items?.length">
    <h6 class="sidebar-section-title mb-2">
      <span>{{ title }}</span>
      <span class="total-badge">{{ total }}</span>
    </h6>

    <div class="sidebar-employee-list">
      <div
          v-for="(item, index) of items"
          :key="index"
          class="sidebar-employee-item">

        <div class="sidebar-employee-data">
          <span class="type-name" :title="item?.name">{{ item?.name }}</span>
          <span class="count-badge">{{ item?.count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
    default: () => []
  }
})

const total = computed(() => props.items?.reduce((sum, item) => sum + (+item?.count || 0), 0));
</script>

<style scoped>
.sidebar-section-title {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.total-badge {
  margin-left: auto;
  font-size: 0.75rem;
  font-weight: 700;
  background-color: v-bind(companyColor);
  color: #ffffff;
  padding: 1px 8px;
  border-radius: 10px;
}

.sidebar-employee-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 280px;
  overflow-y: auto;
  padding-right: 4px;
}

.sidebar-employee-list::-webkit-scrollbar {
  width: 4px;
}
.sidebar-employee-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.sidebar-employee-item {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 10px;
  transition: all 0.2s ease;
}

.sidebar-employee-item:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.sidebar-employee-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
}

.type-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.count-badge {
  font-size: 0.75rem;
  font-weight: 700;
  background-color: v-bind(companyBgColor);
  color: v-bind(companyColor);
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
